import { CRUDProvider } from 'components/providers';
import { useTranslation } from 'react-i18next';
import { ReferenceResources } from 'services/resources/users/reference';

import { Page } from './components/Page';

export const ReferencePage: React.FC = (): JSX.Element => {
  const { t } = useTranslation('references');

  return (
    <CRUDProvider
      allowPost
      quote={t('page.quote')}
      resource={ReferenceResources}
      title={t('page.title')}
    >
      <Page />
    </CRUDProvider>
  );
};
